module.exports = __webpack_public_path__ + "img/logo6.4c43a13c.png";